import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { LocatorLibrary } from 'src/app/locator/models/locator-library';
import { LocatorService } from 'src/app/locator/services/locator.service';
import * as fromLocatorStore from 'src/app/locator-store';
import * as fromUIStore from 'src/app/core/store';

import { DialogMode } from 'src/app/shared/atlas-dialog/enums/dialog-mode.enum';
import { AddEditLibraryFormComponent } from '../add-edit-library-form/add-edit-library-form.component';
import { Store } from '@ngrx/store';
import { createLibraryDialogSaveClicked } from 'src/app/locator-store/actions/locator-library.actions';
import { DialogResult } from 'src/app/shared/atlas-dialog/enums/dialog-result.enum';
import { ProfilerLibrary } from 'src/app/profiler/model/profiler-library';
import { ProfilerService } from 'src/app/profiler/services/profiler.service';

@Component({
  selector: 'atlas-add-library-dialog',
  templateUrl: './add-library-dialog.component.html',
  styleUrls: ['./add-library-dialog.component.less'],
  standalone: false
})
export class AddLibraryDialogComponent implements OnInit {
  dialogMode: DialogMode;
  userLibraries: string[] = [];
  profilerLibraries: ProfilerLibrary[] = [];
  enableProfilerLibrarySelection = false;
  private isLocatorAllowed = false;
  private isProfilerAllowed = false;
  private subscription = new Subscription();

  constructor(
    private locatorService: LocatorService,
    private profilerService: ProfilerService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      entityName: string;
      headerPrefix: string;
      mode: DialogMode;
      library: LocatorLibrary;
      affirmativeButtonText: string;
    },
    private dialogRef: MatDialogRef<AddLibraryDialogComponent>,
    private store$: Store<fromLocatorStore.State>
  ) {}

  ngOnInit() {
    this.getAllLibraries();
    this.getAllProfilerLibraries();
    this.getProfilerLibrarySelectionAvailability();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private getAllLibraries() {
    this.subscription.add(
      this.locatorService
        .getAllLibraries()
        .subscribe((libraries: LocatorLibrary[]) => {
          this.userLibraries = libraries.map((library) => library.name);
        })
    );
  }

  private getAllProfilerLibraries() {
    this.subscription.add(
      this.profilerService
        .getAllProfilerLibraries()
        .subscribe((libraries: ProfilerLibrary[]) => {
          this.profilerLibraries = libraries;
        })
    );
  }

  private getProfilerLibrarySelectionAvailability() {
    this.subscription.add(
      this.store$
        .select(fromUIStore.isLocatorFeatureAllowed)
        .subscribe((isLocatorAllowed) => {
          this.isLocatorAllowed = !!isLocatorAllowed;
          this.updateProfilerLibrarySelectionAvailability();
        })
    );

    this.subscription.add(
      this.store$
        .select(fromUIStore.isProfilerFeatureAllowed)
        .subscribe((isProfilerAllowed) => {
          this.isProfilerAllowed = !!isProfilerAllowed;
          this.updateProfilerLibrarySelectionAvailability();
        })
    );
  }

  private updateProfilerLibrarySelectionAvailability() {
    this.enableProfilerLibrarySelection =
      this.isLocatorAllowed && this.isProfilerAllowed;
  }

  onSaveClicked(addLibraryFormComponent: AddEditLibraryFormComponent) {
    const newLibrary = addLibraryFormComponent.addEditLibraryForm.value;
    if (addLibraryFormComponent.addEditLibraryForm.valid) {
      this.store$.dispatch(
        createLibraryDialogSaveClicked({
          libraryRequest: {
            name: newLibrary.libraryName,
            profilerLibraryId: this.enableProfilerLibrarySelection
              ? addLibraryFormComponent.getSelectedProfilerLibraryId()
              : null
          }
        })
      );
      this.dialogRef.close({
        action: DialogResult.Affirmative,
        data: addLibraryFormComponent.addEditLibraryForm.controls.libraryName
          .value
      });
    }
  }
}
